import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

export const QConfigDuplicationSchema = z.object({
  qConfigName: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, {
      message: 'กรุณากรอกชื่อ QConfig',
    })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อ QConfig ต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    }),
});

export type QConfigDuplicationFormInput = z.infer<typeof QConfigDuplicationSchema>;
